import React, { Component } from 'react';
import CustomSelect from '../../custom/CustomSelect';
import Editor from '@monaco-editor/react';
import {
  apacheHttpClient,
  curlRequest,
  googleHttpClient,
  javaNetHttpClient,
  jQueryHttpClient,
  nodeJsAxiosHttpClient,
  okHttpClient,
  pythonRequestHttpClient,
} from '../../../util/EventCodeSnippets';
import MessageUtil from '../../../util/MessageUtil';
import NavigationUtil from '../../../util/NavigationUtil';
import { AnimatedButton } from '@trlogic/ui-pack';
import LanguageUtil from '../../../util/LanguageUtil';

class CodeSnippetsComponent extends Component<Props, State> {
  public state = new State();

  render() {
    const { selectedCodeSnippet, codeSnippet } = this.state;
    return (
      <div className={'flex flex-col h-full w-full'}>
        <div className={'flex w-full h-[100px] bg-f-gray items-center px-5 py-5'}>
          <div className={'flex items-center justify-start'}>
            <CustomSelect
              value={selectedCodeSnippet}
              onChange={(e) => this.onChangeSelectedCodeSnippet(e.value as CodeSnippets)}
              label={LanguageUtil.get({ id: 'common.label.options', defaultMessage: 'Options' })}
              options={this.getCodeOptions()}
            />
          </div>
        </div>
        <div className={'flex flex-col w-full h-full px-5 py-5 '}>
          <div className={'text-2xs text-f-black-3'}>Body</div>
          <div className={'flex items-center w-full h-full border border-rounded rounded-lg px-5 py-5 '}>
            <Editor language={'java'} value={codeSnippet} />
          </div>
          <div className={'flex w-full items-center justify-end pt-4'}>
            <AnimatedButton
              onClick={this.onClickCopy}
              icon={'save'}
              customType={'primary'}
              text={LanguageUtil.get({ id: 'common.button.copy', defaultMessage: 'Copy' })}
            />
          </div>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const tenant: string = NavigationUtil.getTenant();
    const codeSnippet: string = this.getCodeSnippetByCodeSnippetType(CodeSnippets.JAVANETHTTPCLIENT, tenant);
    this.setState({ codeSnippet: codeSnippet });
  }

  private onClickCopy = async () => {
    const { codeSnippet, selectedCodeSnippet } = this.state;
    try {
      await navigator.clipboard.writeText(codeSnippet);
      MessageUtil.success({
        summary: 'Copied',
        detail: `${selectedCodeSnippet} request model copied`,
      });
    } catch (e) {
      MessageUtil.error({
        summary: 'Error',
        detail: 'Error when copied request model',
      });
    }
  };

  private onChangeSelectedCodeSnippet = (value: CodeSnippets) => {
    const tenant: string = NavigationUtil.getTenant();
    const codeSnippet: string = this.getCodeSnippetByCodeSnippetType(value, tenant);
    this.setState({ selectedCodeSnippet: value, codeSnippet: codeSnippet });
  };

  private getCodeSnippetByCodeSnippetType = (value: CodeSnippets, tenant: string): string => {
    const { request } = this.props;
    const requestJson = request || '';
    switch (value) {
      case CodeSnippets.JAVANETHTTPCLIENT:
        return javaNetHttpClient(tenant, requestJson);
      case CodeSnippets.APACHEHTTPCLIENT:
        return apacheHttpClient(tenant, requestJson);
      case CodeSnippets.CURLREQUEST:
        return curlRequest(tenant, requestJson);
      case CodeSnippets.GOOGLEHTTPCLIENT:
        return googleHttpClient(tenant, requestJson);
      case CodeSnippets.OKHTTPCLIENT:
        return okHttpClient(tenant, requestJson);
      case CodeSnippets.JQUERYHTTPCLIENT:
        return jQueryHttpClient(tenant, requestJson);
      case CodeSnippets.NODEJSAXIOSHTTPCLIENT:
        return nodeJsAxiosHttpClient(tenant, requestJson);
      case CodeSnippets.PYTHONREQUESTHTTPCLIENT:
        return pythonRequestHttpClient(tenant, requestJson);
      default:
        return 'Default Code Snippet';
    }
  };

  private getCodeOptions = () => {
    return (Object.keys(CodeSnippets) as CodeSnippetKeys[]).map((key) => {
      return {
        label: CodeSnippets[key] as string,
        value: CodeSnippets[key] as string,
      };
    });
  };
}

class State {
  selectedCodeSnippet: CodeSnippets = CodeSnippets.JAVANETHTTPCLIENT;
  codeSnippet: string = '';
}

interface Props {
  request: string | undefined;
}

type CodeSnippetKeys = keyof typeof CodeSnippets;

enum CodeSnippets {
  JAVANETHTTPCLIENT = 'Java - Net Http Client',

  APACHEHTTPCLIENT = 'Java - Apache Http Client',

  GOOGLEHTTPCLIENT = 'Java - Google Http Client',

  OKHTTPCLIENT = 'Java - Ok Http Client',

  JQUERYHTTPCLIENT = 'JavaScript - jQuery',

  NODEJSAXIOSHTTPCLIENT = 'NodeJs - Axios',

  PYTHONREQUESTHTTPCLIENT = 'Python - Request',

  CURLREQUEST = 'cURL Request',
}

export default CodeSnippetsComponent;
